import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderComponent } from '../../../../shared/components/header/header.component';
import { LoadingBoxComponent } from '../../../../shared/components/loading-box/loading-box.component';
import { OrigemDocumentoFiscalRecebidoEnum } from '../../../../shared/enums/repo-dfe/origem-documento-fiscal-recebido.enum';
import { FuncionalidadeEnum } from '../../../../shared/enums/usuario/funcionalidade.enum';
import { ModuloEnum } from '../../../../shared/enums/usuario/modulo.enum';
import { AlertService, AlertType } from '../../../../shared/services/alert.service';
import { PainelDFeRecebidoService } from '../../../../shared/services/apis/repo-dfe/painel-dfe-recebido.service';
import { DetalheNFeRecebidoResponse } from '../../../../shared/services/responses/repo-dfe/detalhe-nfe-recebido.response';
import { NFeDetalheComponent } from '../nfe-detalhe/nfe-detalhe.component';

@Component({
  selector: 'app-detalhe-nfe-recebido', standalone: true,
  imports: [HeaderComponent, LoadingBoxComponent, NFeDetalheComponent],
  templateUrl: './detalhe-nfe-recebido.component.html',
  styleUrls: ['./detalhe-nfe-recebido.component.css']
})
export class DetalheNFeRecebidoComponent implements OnInit {
  readonly moduloEnum = ModuloEnum.NotasFiscais;
  readonly funcionalidadeEnum = FuncionalidadeEnum.NotasFiscais_PainelNotaRecebida;
  isLoading = true;
  idNFeRecebido = 0;
  origemDocumentoFiscalRecebido: OrigemDocumentoFiscalRecebidoEnum;
  documento: DetalheNFeRecebidoResponse | null = null;

  constructor(private route: ActivatedRoute, private router: Router,
    private service: PainelDFeRecebidoService, private alert: AlertService) { }

  ngOnInit(): void {
    this.idNFeRecebido = Number(this.route.snapshot.paramMap.get('idNFeRecebido'));
    this.origemDocumentoFiscalRecebido = Number(this.route.snapshot.queryParamMap.get('origemDocumentoFiscalRecebido'));
    if (!this.idNFeRecebido || ![OrigemDocumentoFiscalRecebidoEnum.EstruturaAntiga, OrigemDocumentoFiscalRecebidoEnum.EstruturaNova].includes(this.origemDocumentoFiscalRecebido)) {
      this.alert.show('Erro', 'NF-e recebida inválida.', AlertType.error);
      this.router.navigate(['/notas-fiscais/notas-recebidas']);
      return;
    }
    this.carregarDados();
  }

  carregarDados(): void {
    this.isLoading = true;
    this.documento = null;
    this.service.obterNFeRecebido(this.idNFeRecebido, this.origemDocumentoFiscalRecebido).subscribe({
      next: response => {
        this.isLoading = false;
        if (response.isError) {
          this.alert.show('Aviso', response.errorDescription, AlertType.warning);
          this.router.navigate(['/notas-fiscais/notas-recebidas']);
          return;
        }
        this.documento = response;
      },
      error: error => { this.isLoading = false; this.alert.show('Erro inesperado', error.message, AlertType.error); }
    });
  }
}
